var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ht-tab-wrap"},[_c('b-tabs',{staticClass:"ht-tab-menu wow move-up"},[_c('b-tab',{attrs:{"title":"服務方案","active":""}},[_c('TabContentOne')],1),_c('b-tab',{attrs:{"title":"客戶服務"}},[_c('TabContentThree')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }